<template>
    <v-container fluid id="about" class="" style="border:0px solid red;font-size:16px;">

        <v-row class="window-content" align="center">
            <v-col cols="12" md="12" lg="6" xl="6" justify="left" align="left">
                <block>
                <div style="height:40px;"></div>
                <h4 class="
                    text-h5
                    text-md-h5
                    text-lg-h5
                    text-xl-h5
                    " style=""
                >
                Getting started
                </h4>

                <div style="height:20px;"></div>
                <p class="" style="font-size:16px;">
                    Onkopus is a variant interpretation framework for biomedical research and clinicians to analyze and interpret
                    genetic variants.
                    Onkopus provides a comprehensive biological and clinical interpretation of
                    sequence variants, including novel annotations with biochemical and protein features, and
                    interactive visualizations to analyze genetically altered proteins.
                    <br /><br />
                    You can directly search for variants at genomic, transcript or protein level,
                    as well as upload sequence variant
                    files in different file formats (VCF, MAF, CSV). <br /><br />
                    Onkopus is available as a web application, a Python package, and workflows for the analytical framework KNIME.
                </p>
                </block>

            </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="12" md="12" lg="6" xl="6" justify="left" align="left">
                    <div class="window-content">
                        <h5>
                            Pathogenicity prediction
                        </h5>
                        <p>
                            Compare pathogenicity and variant effect predictions of numerous computational methods.
                        </p>
                    </div>
                </v-col>
                <v-col cols="12" md="12" lg="6" xl="6" justify="left" align="left">
                    <div style="margin:auto;margin-top:40px;">
                        <img src="@/assets/pathogenicity_v0.1.png" width="800" style="margin:auto;padding:2px;" />
                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row style="height:600px;">
                <v-col cols="12" md="12" lg="6" xl="6" justify="center" align="center">
                    <div style="margin:auto;margin-top:40px;">
                        <img src="@/assets/img_protein_v0.2.jpg" width="800" style="margin:auto;padding:2px;" />
                    </div>
                </v-col>
                <v-col cols="12" md="12" lg="6" xl="6" justify="left" align="left">
                    <v-row style="height:400px;">
                        <v-col cols="12" md="12" lg="8" xl="8" justify="left" align="left">
                            <div class="window-content">
                                <h5>
                                    Protein structure analysis
                                </h5>
                                <p>
                                    Explore genetic alterations within the context of the entire protein. <br />

                                    Analyze protein features, including the predicted protein structure,
                                    pathogenicity, binding site prediction,
                                    surface accessibility, alpha carbon distances and the secondary protein structure.
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row style="height:600px;" align="center">
                <v-col cols="12" md="12" lg="4" xl="4" justify="center" align="left">
                    <div class="window-content">
                        <h5>
                            Visually browse clinical evidence for molecular biomarkers
                        </h5>
                        <p>
                            Find possible therapies by browsing the clinical evidence of variants in interactive sunburst graphs.
                        </p>
                    </div>
                </v-col>
                <v-col cols="12" md="12" lg="8" xl="8" justify="center" align="center">
                    <div style="margin:auto;margin-top:40px;">
                    <img src="@/assets/about_04_sunbursts_0.1.jpeg" width="800" style="margin:auto;padding:2px;" />
                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row style="height:600px;" align="center" justify="center">
                <!--<v-col cols="12" md="12" lg="6" xl="6" justify="center" align="left">
                    <div class="window-content">
                        <p>
                            <b>Variant search</b>
                            <ul>
                                <li>Genomic locations (chr7:140753336A%3ET)</li>
                                <li>Protein variants (BRAF:V600E)</li>
                                <li>Gene fusions ()</li>
                                <li>Genes (BRAF)</li>
                            </ul>
                        </p>

                        <p>
                            <b>File Upload</b><br/>
                            Supported file formats
                            <ul>
                                <li>VCF</li>
                                <li>MAF</li>
                                <li>CSV/TSV</li>
                                <li>XLSX</li>
                            </ul>
                        </p>
                    </div>
                </v-col>-->
                <v-col cols="12" md="12" lg="12" xl="12" justify="left" align="left">
                    <div class="window-content">
                    <p>Onkopus (v1.0.0, 12-2024) provides the following data sources:</p>
                        <div style="height:20px;"></div>

                    <p>
                        <b>Annotation Features</b><br/>
                            Onkopus provides a comprehensive overview of the most important characteristics of genetic mutations:
                            <ul>
                                <li style="margin-top:5px;"><span><b>Transcript and protein data:</b> Genomic data, protein sequences, population
                                    frequency
                                    </span><br/>
                                    <span style="width:150px;">
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">hgvs</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">gnomAD</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">dbSNP</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">1000Genomes</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">ExAC</v-btn>
                                    </span>
                                </li>
                                <!--<li style="margin-top:5px;"><b>Functional effect prediction:</b> Recognize loss or gain of function (LoF/GoF)
                                    proteins<br/>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">SIFT</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">PolyPhen2</v-btn>
                                </li>-->
                                <li style="margin-top:5px;"><b>Functional regions:</b>Exons, coding sequences (CDS) and untranslated regions (UTRs)<br/>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">GENCODE</v-btn>
                                </li>
                                <li style="margin-top:5px;"><b>Pathogenicity and variant effect prediction:</b> Pathogenicity scores<br/>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">AlphaMissense</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">REVEL</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">MVP</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Missense3D</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">PrimateAI</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">SIFT</v-btn>
                                    <span style="padding-left:5px;">etc.</span>
                                </li>
                                <li style="margin-top:5px;">
                                    <b>Protein structure analysis: </b>Analyze the 3D protein structure, relative accessible surface area (RelASA)
                                    and the secondary structure at a variant position<br />
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">RSA</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Alpha carbon distances</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Secondary protein structure</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Binding site predictions</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Protein sequences</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Protein domain</v-btn>
                                </li>
                                <li style="margin-top:5px;">
                                    <b>Molecular features: </b>
                                    Biochemical features of variants<br />
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Molecular weight</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Charge</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Aromaticity</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Ionization</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Flexibility</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">Phosphorylation</v-btn>
                                </li>
                                <li style="margin-top:5px;">
                                    <b>Gene Expression: </b>Average gene expression per tissue<br />
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">GTEx</v-btn>
                                </li>
                                <li style="margin-top:5px;"><b>Clinical evidence:</b> Possible treatments and their scientifically proven effect on
                                    cancer biomarkers<br/>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">CIViC</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">OncoKB</v-btn>
                                    <v-btn density="compact" color="blue-grey-lighten-2" style="margin-left:5px;">MetaKB</v-btn>
                                </li>
                            </ul>
                    </p>
                    </div>

                </v-col>
                <v-col cols="1" md="1" lg="1" xl="1">
                </v-col>
            </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col>
                <!-- Variant search sample -->
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <!-- Variant pathogenicity view sample -->
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <!-- Variant clinical evidence sample -->
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <!-- KNIME workflow sample -->
            </v-col>
        </v-row>

        <v-row>
                <v-col cols="1" md="1" lg="1" xl="1">
                </v-col>
                <v-col cols="10" md="10" lg="10" xl="10">

                </v-col>
                <v-col cols="1" md="1" lg="1" xl="1">
                </v-col>
        </v-row>

        <!--<v-row class="bg-surface-variant" style="">
            <v-col></v-col>
            <v-col cols="11" md="11" lg="10" xl="10">
            <div class="">
                <div style="height:10px;"></div>
                <p>Onkopus (v1.0.0, 12-2024) provides the following data sources:</p>
                <div style="height:20px;"></div>

                Biochemical Features
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">GENCODE</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">gnomAD</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">hgvs</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">1000Genomes</v-sheet>
                </div>

                Pathogenicity Scores
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">REVEL</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">MVP</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">PrimateAI</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">LoFTool</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">VUS-Predict</v-sheet>
                </div>

                Functional Effect Prediction
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">VEP</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">SIFT</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">PolyPhen2</v-sheet>
                </div>

                Manual Pathogenicity Estimations
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">ClinVar</v-sheet>
                </div>

                Variant Population Frequency
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">dbSNP</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">gnomAD</v-sheet>
                </div>

                Drug-Gene Interactions
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">DgIDB</v-sheet>
                </div>

                Fusion Gene Features
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">FusionGDB</v-sheet>
                </div>

                Clinical Evidence
                <div class="d-flex flex-row mb-6">
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">CIViC</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">OncoKB</v-sheet>
                    <v-sheet class="ma-2 pa-2 bg-surface-variant rounded-lg" style="border:1px solid #00dff5;">MetaKB</v-sheet>
                </div>

            </div>

            </v-col>
            <v-col cols="0" md="0" lg="3" xl="3">
            </v-col>
        </v-row>-->

    </v-container>
</template>
<script>

export default {
    data: () => ({
        length: 3,
        window:0,
    })
}

</script>
<style scoped>

#about {
    font-size: 14px;
    font-family: var(--default-font);
    /*width: 70% !important;
    margin: 32px auto;*/
}

.window-content {
    padding-left:120px;
    padding-top:40px;
    padding-bottom:120px;
}

</style>
